import validate from "/usr/src/app/content/n3-redirections-spa-5694e709-9921-4eb8-931f-235b9cf1abcf/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-spa-5694e709-9921-4eb8-931f-235b9cf1abcf/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}